export const CO_GET_OFFERSTATUS_LISTING = "CO_GET_OFFERSTATUS_LISTING"
export const CO_GET_OFFERSTATUS_LISTING_SUCCESS = "CO_GET_OFFERSTATUS_LISTING_SUCCESS"
export const CO_GET_OFFERSTATUS_LISTING_FAILED = "CO_GET_OFFERSTATUS_LISTING_FAILED"